// @flow
import unifiedCookiesPolicy from './components/UnifiedCookiesPolicy/index';
import cookiesPolicyMotive from './components/UnifiedCookiesPolicy/img/motive.png';

// Cookies policy
unifiedCookiesPolicy({
  position: "center",
  color: "green",
  type: "multi",
  enableSplitGTMContainer: true,
  enableOneGTMContainer: true,
  logoImgSrc: "/img/logo/logo-sm.svg",
  logoImgAlt: "Warehouse #1",
  motiveImgSrc: cookiesPolicyMotive,
});

import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import phoneLink                     from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';
// import('./components/plUpload/fg.upload');                // PL upload
// import 'bootstrap/js/dist/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();

// Nastaveni sirky scrollbaru do property
document.documentElement.style.setProperty('--scrollbar-width', `${ window.innerWidth - document.documentElement.clientWidth }px`);


// TODO MAL Webcomponent

import Tabby from 'tabbyjs/dist/js/tabby.min';

const fulltextResltsPage = document.querySelector('.page-container--fulltext');
if (fulltextResltsPage) {
  document.body.classList.add('fulltext-results');
	// Tabby js for fulltext
	const tabs = new Tabby('[data-tabs]');

	// Toggling category tab
	if (tabs) {

		setTimeout(() => {
			const tabbyContent = document.querySelector('.fulltext-results-container');
			if (tabbyContent) tabbyContent.classList.remove('fulltext-results-container--hidden');
			const tabsItems = document.querySelectorAll('.fulltext-controls__link');

			const urlString = window.location.href;
			const url = new URL(urlString);
			const section = url.searchParams.get('section');

			if (tabsItems) {
				if (section) {
					const preferedItem = document.getElementById(`tabby-toggle_${ section }`);
					preferedItem.click(); // click on prefered tab (link form Autocomplete section)
				} else {
					let containsProductsResults = false;
					tabsItems.forEach((item, index) => {
						const attr = item.getAttribute('href');
						if (attr === '#fulltextResultsContainerProducts') {
              // console.log('containsProductsResults=true');
              containsProductsResults = true;
            }
					});
					if (containsProductsResults) {
            const productTab = document.querySelector('[aria-controls=fulltextResultsContainerProducts]');// find product tab
            // console.log('productTab Element = ', productTab);
            productTab.click(); // and click o it
					} else {
						tabsItems[ 0 ].click(); // first item click
					}
				}
			}
		}, 200);

		document.addEventListener('tabby', (event) => {
			const content = event.detail.content;
			content.classList.remove('hidden');
		}, false);
	}
}



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/configureWeb.js